import { useNavigate } from 'react-router-dom';
import download from '../../assets/images/download.svg'

const AllSet = () => {
    const navigate = useNavigate()
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = `${process.env.PUBLIC_URL}/brainyagent-extension.zip`;
        link.download = "brainyagent-extension.zip"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
            navigate('/dashboard')
        }, 500);
    };
    return (
        <>
            <div>
                <div className='d-flex flex-column gap-24'>
                    <h1 className='font-45'>You’re All Set!</h1>
                    <p className='font-18-white'>
                        Thanks for giving us permission to link to your data.
                        <p className='font-18-white'>BrainyAgent is now ready to help you make sense of your files.</p>
                    </p>
                    <p className='font-18-white'>Next Step, Install the browser plugin to start using BrainyAgent.</p>

                    <div className='d-flex gap-24 align-items-center'>
                        <button
                            type="submit"
                            className='theme-blue-btn1'
                            style={{ borderRadius: '100px' }}
                            onClick={handleDownload}
                        >
                            <img src={download} alt="download" />
                            Download Plugin
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AllSet;
